import { useEffect, useState } from "react";
import { fetchMailProviders } from "@/lib/api/accounts";
import type { MailProviderPreset } from "@/lib/types/mail";

export function useMailProviders() {
  const [providers, setProviders] = useState<MailProviderPreset[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void fetchMailProviders().then((res) => {
      if (cancelled) return;
      if (res.ok) setProviders(res.data.providers ?? []);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { providers, loading };
}
